import {
  useMutation,
  UseMutationOptions,
} from "@tanstack/react-query";
import {
  deleteCheckoutLink,
  DeleteCheckoutLinkParams,
} from "@/api/v1-jwt/checkout/checkout";

export const useDeleteCheckoutLink = (
  options?: Omit<
    UseMutationOptions<void, Error, DeleteCheckoutLinkParams>,
    "mutationFn"
  >
) => {
  return useMutation<void, Error, DeleteCheckoutLinkParams>({
    mutationFn: deleteCheckoutLink,
    ...options,
  });
};
